export default __webpack_public_path__ + "videos/preloader.mp4";